import { typeNameCard } from "../types/typeTexture";

export const selectView360 = (moveMapTexture = [], nameselect = "") => {
	const findSelect = moveMapTexture.findIndex((spot) => spot.name === nameselect);
	if (findSelect === -1) {
		return {
			status: 1,
		};
	}
	const { name, material, camarePosition, moveHotSpotArrow } = moveMapTexture[findSelect];
	// console.log(moveMapTexture[findSelect]);
	return {
		status: 0,
		camarePosition,
		name,
		material,
		moveHotSpotArrow,
	};
};

export const selectView360Modal = (moveMapTexture = [], nameselect = "") => {
	const findSelect = moveMapTexture.findIndex((spot) => spot.name === nameselect);
	if (findSelect === -1) {
		return {
			status: 1,
		};
	}
	const { name, material, camarePosition, moveHotSpotArrow } = moveMapTexture[findSelect];
	return {
		status: 0,
		name,
		material,
		camarePosition,
		moveHotSpotArrow,
	};
};

export const moveMenu = (name) => {
	let namesCard = [];
	for (const key in typeNameCard) {
		if (Object.hasOwnProperty.call(typeNameCard, key)) {
			const element = typeNameCard[key];
			namesCard.push(element);
		}
	}
	if (namesCard.includes(name)) {
		return {
			status: 0,
			name,
		};
	} else {
		return {
			status: 1,
		};
	}
};
